import React from 'react';
import { renderContent } from 'utilities/content/content-utilities';
import { Typography } from '@tvg/fuse/typography';
import { DialogSection, DialogText, DialogDivider } from '../../styles/DialogStyles';

function YouCouldPayInformation() {
  return (
    <>
      <DialogSection data-testid="you-could-pay-information">
        <Typography data-testid="you-could-pay-heading1" size="1" tag="h2" type="heading">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading1.heading')}
        </Typography>

        <DialogText data-testid="you-could-pay-heading1-info-1" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading1.info1')}
        </DialogText>

        <DialogText data-testid="you-could-pay-heading1-info-2" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading1.info2')}
        </DialogText>

        <DialogText data-testid="you-could-pay-heading1-info-3" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading1.info3')}
        </DialogText>
      </DialogSection>

      <DialogSection>
        <Typography data-testid="you-could-pay-heading2" size="1" tag="h2" type="heading">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading2.heading')}
        </Typography>

        <DialogText data-testid="you-could-pay-heading2-info-1" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading2.info1')}
        </DialogText>

        <DialogText data-testid="you-could-pay-heading2-info-2" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading2.info2')}
        </DialogText>

        <Typography data-testid="you-could-pay-heading2-info-3" size="1" tag="span" type="heading">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading2.info3.highlightedText')}
        </Typography>

        <DialogText data-testid="you-could-pay-heading2-info-3" size="1" tag="span" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading2.info3.text')}
        </DialogText>
      </DialogSection>

      <DialogSection>
        <Typography data-testid="you-could-pay-heading3" size="1" tag="h2" type="heading">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading3.heading')}
        </Typography>

        <DialogText data-testid="you-could-pay-heading3-info-1" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading3.info1')}
        </DialogText>

        <DialogText data-testid="you-could-pay-heading3-info-2" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading3.info2')}
        </DialogText>

        <DialogText data-testid="you-could-pay-heading3-info-3" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading3.info3')}
        </DialogText>

        <DialogText data-testid="you-could-pay-heading3-info-4" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.heading3.info4')}
        </DialogText>
      </DialogSection>

      <DialogDivider />

      <DialogSection>
        <DialogText data-testid="bnpl-dialog-footer" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.youCouldPay.footer')}
        </DialogText>
        <DialogText data-testid="bnpl-dialog-footer" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.footer')}
        </DialogText>
      </DialogSection>
    </>
  );
}

export default YouCouldPayInformation;
